import { useSearchParams } from 'react-router-dom'

import { BundleContainer } from './BundleContainer'

export const Bundle = () => {
    // #region HOOKS
    const [searchParams] = useSearchParams()

    //#region STATE
    const productCode = searchParams.get('productCode')
    //#endregion

    return (
        <BundleContainer productCode={productCode} />
    )
}